export default __webpack_public_path__ + "static/media/preview-sections.12a18473.png";